<template>
  <div class="outer" v-if="user">
    <b-form-radio-group v-if="isAdmin" size="sm" :class="{pillbox: true, dark}" buttons button-variant="clear"
      :checked="choice" @input="input">
      <b-form-radio value="private"><i class="fas fa-user"/> Private</b-form-radio>
      <b-form-radio value="shared"><i class="fas fa-users"/> Shared with Team</b-form-radio>
    </b-form-radio-group>

    <small v-else><i class="fas fa-user"></i> Your card will only be available to you</small>
  </div>
</template>

<style lang="scss" scoped>
@import '~scss/colors';

.btn-group > .btn-clear:first-child {
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
}
.btn-group > .btn-clear:last-child {
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
}
.btn-clear {
  border: 1px solid #ccc;
  padding: 8px 15px;
  height: auto;
  color: #aaa;
  &.active {
    color: #222;
    background: $gray-2;
  }
}

.pillbox {
  margin-top: 0.5em;
  margin-bottom: 0.5em;
}

.dark {
  .btn-clear.active {
    background:#ddd;
  }
}
</style>

<script>
import {mapGetters} from 'vuex';
export default {
  props: {value: Boolean, dark: Boolean},
  computed: {
      ...mapGetters(['user', 'isAdmin']),
    choice() {
      return this.value ? 'private' : 'shared';
    }
  },
  methods: {
    input($event) {
      this.$emit('input', $event === 'private');
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/PrivateToggle.vue